import type { DashboardRowType } from '@shared/types/Dashboard';

export const homeStatusDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 7,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 0,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 2,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 1,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 4,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 8,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 13,
      },
    ],
  },
];
